import React from 'react'
import { graphql } from 'gatsby'
import SEO from '../components/seo'
import styled from 'styled-components'

const PostSection = styled.div`
  margin: 2em 0;
`

const ImageSection = styled.div`
  max-width: 700px;
  margin: 0 auto;
  
  div {
    position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
  }

  iframe {
    position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  }

  div {
    margin: 0 0 2em;
  }
`



const Title = styled.h1`
  font-size: 0.9em;
  font-weight: normal;
  text-transform: uppercase;

  @media screen and (max-width: 800px) {
    margin-bottom: 2em;
  }
`

const FilmPage = ({ data }) => {
  const collection = data.prismicFilm
  return (
    <>
      <SEO title={collection.data.title.text}
      image="https://www.datocms-assets.com/27639/1589311445-d2a63f1a21a95029e54fc09494047c7b813422mv2.jpg" />
      <div>
        <PostSection>
          <div>
            <Title> {collection.data.title.text}</Title>
          </div>

          <ImageSection
            dangerouslySetInnerHTML={{
              __html: collection.data.content.text,
            }}
          />
        </PostSection>
      </div>
    </>
  )
}

export const query = graphql`
  query($id: String!) {
    prismicFilm(id: { eq: $id }) {
      id
      data {
        title {
          text
        }
        content {
          text
        }
      }
    }
  }
`

export default FilmPage
